//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex"
import Theme from '@/listing-app/mixins/Theme'
import ManageHeaderApply from "@/listing-app/mixins/ManageHeaderApply";
import ExpandTransition from "@/listing-app/components/ExpandTransition"


export default {
	name: "Select",
	mixins: [Theme, ManageHeaderApply],
	props: ["data", "terms"],
  components: {
		appExpandTransition: ExpandTransition
  },
	data() {
		return {
			open: false
		}
	},
  computed: {
    ...mapGetters(["read"]),
    selectedText() {
      if (this.terms) {
        return this.read("term").Text
      } else {
        return this.read("filters")[this.data.ID].text
      }
    },
    selectedID() {
      if (this.terms) {
        return this.read("term").ID
      } else {
        return this.read("filters")[this.data.ID].value
      }
    }
  },
  methods: {
    ...mapActions(["set"]),
    init() {
      if (!this.terms) {
        if (!this.read("filters").hasOwnProperty(this.data.ID)) {
          let defaultAvailable = false
          for (let option of this.data.Values) {
            if (option.hasOwnProperty("Default") && option.Default == true) {
              this.update_selection(option)
              defaultAvailable = true
            }
          }
          if (!defaultAvailable) {
            this.update_selection(this.data.Values[0])
          }
        }
      }
    },
    update_selection(option) {
      if (this.terms) {
        let _term
        this.read('property').Terms.forEach(term => {
          if (term.ID == option.ID) {
            _term = term
            this.set_header_apply_term(_term.ID);
          }
        })

        if (!_term) {
					console.time('load_term')
					this.set({muta: 'loaded', data: false})
          this.$api
            .get(option.Route)
            .then(res => {
							this.set({muta: 'storeTerm', data: res})
							this.set({muta: 'term', data: res})
							this.set({muta: 'loaded', data: true})
              this.set_header_apply_term(res.ID);
              console.timeEnd('load_term')
            })
            .catch(err => {
							this.set({muta: 'error', data: true})
            })
        } else {
					this.set({muta: 'term', data: _term})
        }
			} 
			else {
        let filter = this.data.ID
        let value = option.ID
        let text = option.Text

        this.set({muta: 'filters', data: { filter, value, text }})
      }
    },
    toggle() {
      this.open = !this.open
    },
    click(e) {
      if (e.type == "click") {
        if (e.target.closest(".select") != this.$el) {
          this.open = false
        }
      } else if (e.type == "keyup") {
        if (e.target.closest(".select") != this.$el) {
          this.open = false
        }
        if (e.target.closest(".select") == this.$el && e.code == "Escape") {
          this.open = false
        }
      }
    }
  },
  created() {
    this.init()
    window.addEventListener("click", this.click)
    window.addEventListener("keyup", this.click)
  },
  beforeDestroy() {
    window.removeEventListener("click", this.click)
    window.addEventListener("keyup", this.click)
  }
}
